import React from 'react';
import { Search, TrendingUp, ArrowRight } from 'lucide-react';
import { IDX_WIDGETS, IDX_BROKER_AGENT_ID } from '../../constants/idx';
import { IDX_BASE_URL } from '../../constants/site';
import { useIdxWidget } from '../../hooks/useIdxWidget';
import { IdxWidgetContainer } from './IdxWidgetContainer';

export const FeaturedListingsSection = () => {
  const showcaseRef = useIdxWidget(IDX_WIDGETS.showcase);

  return (
    <section
      id="featured-listings"
      className="py-16 sm:py-24 bg-gradient-to-b from-sand-100 to-white"
      data-testid="featured-listings-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 space-y-6">
          <div className="inline-flex items-center space-x-3 px-6 py-3 bg-sand-50 border-2 border-blue-200/60 rounded-full shadow-lg">
            <TrendingUp className="w-5 h-5 text-[#143160]" />
            <span className="text-sm font-bold text-gray-700 tracking-wide uppercase">Live from Swell IDX</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-serif font-bold leading-tight">
            Jess's Active
            <span className="block gold-gradient-text">Listings</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Search live inventory, auto-updated straight from the REIN MLS via Swell Realty's IDX feed.
          </p>
        </div>

        {/* IDX Broker showcase widget lights up once Swell supplies the UID in constants/idx.js */}
        {IDX_WIDGETS.showcase && <div ref={showcaseRef} className="idx-showcase-container mb-10" data-testid="idx-showcase-widget" />}

        <IdxWidgetContainer />

        <div className="text-center mt-10">
          <a
            href={IDX_BASE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="view-all-agent-listings"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#143160] to-[#1E4A86] hover:from-[#1E4A86] hover:to-[#143160] text-white px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:scale-105 transition-all"
          >
            <Search className="w-5 h-5" />
            <span>View All Jess's Listings</span>
            <ArrowRight className="w-5 h-5" />
          </a>
          <p className="text-xs text-gray-500 mt-3">Powered by IDX Broker · Agent ID {IDX_BROKER_AGENT_ID}</p>
        </div>
      </div>
    </section>
  );
};
